import { clearOnActive, inputIsNotEmpty, inputValue, onEnter, revertOnEmpty } from "../../../util/util";
import styles from './Search.module.css'

const Search = ({ name, onChange, defaultValue = null, action = undefined, clearOnClick = false, children }) => {

    return (
        <div id={name} data-testid={name} className={ styles.textInput }>
            <input
                type='text'
                placeholder={'Search...'}
                defaultValue={defaultValue}
                onChange={ inputValue(onChange) }
                onClick={ clearOnActive(defaultValue, clearOnClick) }
                onBlur={ revertOnEmpty(defaultValue) }
                onKeyDown={ onEnter(action, inputIsNotEmpty) }
            />
            {
                action && children && <button onClick={ action }>{ children }</button>
            }
        </div>
    )
}

export default Search
